import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Music2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const googleLogin = () => {
  const redirect = `${window.location.origin}/auth/callback`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
};

const ROLES = [
  { v: "public", l: "Fan / Visitor" },
  { v: "artist", l: "Artist / Band" },
  { v: "venue", l: "Venue Owner" },
  { v: "promoter", l: "Event Promoter" },
];

export default function Register() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "public" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setSession(data.token, data.user);
      nav("/dashboard");
    } catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  };

  const inp = "w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-4 py-3 outline-none focus:border-rose-500";
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="register-page">
      <div className="w-full max-w-md bg-[#111] border border-white/10 rounded-2xl p-8">
        <div className="flex items-center gap-2 mb-6"><Music2 className="text-rose-500" /><span className="font-display font-extrabold text-xl">Join Gulf Coast VIP</span></div>
        {err && <p className="bg-rose-500/10 text-rose-300 text-sm rounded-lg px-4 py-2 mb-4" data-testid="register-error">{err}</p>}
        <form onSubmit={submit} className="space-y-4">
          <input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inp} data-testid="register-name" />
          <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inp} data-testid="register-email" />
          <input type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inp} data-testid="register-password" />
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className={inp} data-testid="register-role">{ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}</select>
          <button disabled={busy} className="w-full bg-rose-500 hover:bg-rose-600 font-bold py-3 rounded-lg transition-colors disabled:opacity-50" data-testid="register-submit">{busy ? "..." : "Create account"}</button>
        </form>
        <p className="text-[11px] text-zinc-500 text-center mt-3" data-testid="register-rewards-note">
          Includes free enrollment in <span className="text-rose-400 font-bold">Gulf Coast VIP Rewards</span> — you'll start with a 250 VIP Point welcome bonus.
        </p>
        <div className="flex items-center gap-3 my-5 text-zinc-500 text-xs"><div className="flex-1 h-px bg-white/10" /> OR <div className="flex-1 h-px bg-white/10" /></div>
        <button onClick={googleLogin} className="w-full border border-white/20 hover:bg-white/5 font-medium py-3 rounded-lg" data-testid="google-register">Continue with Google</button>
        <p className="text-sm text-zinc-400 mt-6 text-center">Have an account? <Link to="/login" className="text-rose-400">Login</Link></p>
      </div>
    </div>
  );
}
